import Image from 'next/image'
import type { FunctionComponent } from 'react'
import type { getMediaItems } from '../utilities/getMediaItem'
import { Container } from './Container'
import s from './MediaMapDetail.module.sass'
import { PageTitle } from './PageTitle'
import { Link } from './Link'
import { Icon } from './Icon'
import parse from 'html-react-parser'

type MediaItemType = Awaited<ReturnType<typeof getMediaItems>>[number]

export type MediaItemsDetailProps = {
	itemSlug: MediaItemType
	backLink?: string
}

export const MediaItemsDetail: FunctionComponent<MediaItemsDetailProps> = ({ itemSlug, backLink }) => {
	return (
		<Inner
			nazev={itemSlug.detail_o_webu?.nazev[0]}
			adresa_webu={itemSlug.detail_o_webu?.adresa_webu[0]}
			screenshot={itemSlug.detail_o_webu?.screenshot[0]}
			kategorie={itemSlug.detail_o_webu?.kategorie[0]}
			popis={itemSlug.detail_o_webu?.popis[0]}
			datum_posledniho_hodnoceni={itemSlug.detail_o_webu?.datum_posledniho_hodnoceni[0]}
			kriteria={
				itemSlug.kriteria?.map((k) => ({
					nazev_kriteria: k.nazev_kriteria[0] || '',
					popis: k.popis[0] || '',
					hodnoceni: k.hodnoceni?.[0],
				})) || []
			}
			slug={itemSlug.slug}
			backLink={backLink}
		/>
	)
}

const Inner: FunctionComponent<{
	nazev?: string
	adresa_webu?: string
	screenshot?: string
	kategorie?: string
	popis?: string
	datum_posledniho_hodnoceni?: string
	kriteria?: { nazev_kriteria: string; popis: string; hodnoceni?: string | undefined }[]
	slug: string
	backLink?: string
}> = ({ nazev, screenshot, popis, datum_posledniho_hodnoceni, kriteria, backLink }) => {
	return (
		<>
			<PageTitle title={nazev} />

			<Container size="normal">
				<div className={s.Cover}>
					{screenshot?.includes('http') && (
						<div className={s.ImageWrapper}>
							<Image className={s.screenshot} src={screenshot} width={639} height={371} alt="obrázek" />
						</div>
					)}
				</div>
				{backLink && (
					<Link href={backLink} className={s.BackLink}>
						<span className={s.Icon}>
							<Icon name="arrow" />
						</span>
						Zpět
					</Link>
				)}
			</Container>
			<Container>
				<div className={s.Content}>
					<div className={s.Texts}>
						{popis && <div className={s.Info}>{parse(popis)}</div>}
						<div className={s.datum_posledniho_hodnoceni_text}>
							<span>Datum posledního hodnocení:</span>

							<p className={s.datum_posledniho_hodnoceni}>{datum_posledniho_hodnoceni}</p>
						</div>
					</div>
					<ul className={s.Criterions}>
						{kriteria?.map((kriterie) => (
							<li key={kriterie.nazev_kriteria} className={s.Criterion}>
								<div className={s.CriterionIn}>
									<p className={s.nazev_kriteria}>{kriterie.nazev_kriteria}</p>

									{kriterie.nazev_kriteria !== 'Původnost textů' && (
										<div className={s.UrovenKriterie}>
											<p className={s.nazev_hodnoceni}>Úroveň:</p>
											{kriterie.hodnoceni ? (
												<p className={s.hodnoceni}>{kriterie.hodnoceni}</p>
											) : (
												<p className={s.hodnoceni}>-</p>
											)}
										</div>
									)}
									<div className={s.popis_kriteria}>{parse(kriterie.popis)}</div>
								</div>
							</li>
						))}
					</ul>

					<div style={{ marginBottom: '3rem', color: '#666', fontStyle: 'italic' }}>
						<p>
							Pokud jste našli v hodnocení chybu, nepřesnost či neaktuální informaci, prosíme o upozornění na
							mapamedii@nfnz.cz.
						</p>
					</div>
				</div>
			</Container>
		</>
	)
}
